// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LnTG","label":"styles_label__N1t2R"};